import styled from "styled-components";

const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
`;

export default LoadingContainer;
